import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import loaderHalfCircle from '../assets/loader-half-circle.svg';

const StepLoader = ({ isAppLoading }) => {
  const classNames = isAppLoading ? '-visible ' : '';
  const [longWaitMessage, setLongWaitMessage] = useState(0);

  useEffect(
    () => {
      if (isAppLoading) {
        setTimeout(() => {
          setLongWaitMessage(1);
        }, 20000);
        setTimeout(() => {
          setLongWaitMessage(2);
        }, 60000);
      } else {
        setLongWaitMessage(0);
      }
      return () => setLongWaitMessage(0);
    },
    [isAppLoading],
  );

  const renderLongWaitMessage = () => {
    switch (longWaitMessage) {
      case 0:
        return '';
      case 1:
        return <p>En espera de respuesta del servidor.</p>;
      case 2:
        return <p>¡Seguimos procesando tu operación! Algunas pueden tomar varios segundos.</p>;
      default:
        return '';
    }
  };

  return (
    <div className={`step-loader ${classNames}`}>
      <div className="contents">
        <img src={loaderHalfCircle} alt="Cargando" />
        {renderLongWaitMessage()}
      </div>
    </div>
  );
};

StepLoader.defaultProps = {
  isAppLoading: false,
};

StepLoader.propTypes = {
  isAppLoading: PropTypes.bool,
};

export default StepLoader;
